export const isISOString = (string: string) => {
    const pattern =
        /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|1[0-9]|2[0-9]|3[0-1])T(0[0-9]|1[0-9]|2[0-3]):([0-5][0-9])(:[0-5][0-9])?(\.\d*)?(Z|([\-\+](0[1-9]|1[0-4])\:00))$/

    return pattern.test(string)
}
